export default __webpack_public_path__ + "static/why_3-811d1fc606617b7ee564a6be1d5ad6ae.gif";